import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-odl',
    templateUrl: './odl.component.html',
    styleUrls: ['./odl.component.scss']
})
export class OdlComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
